import { useEffect } from 'react';
import { useAuth } from '../../public/site/AuthProvider';
import { useNotifications } from '../../public/site/NotificationProvider.js';
import { addNotificationWithoutTimer, removeNotification } from '../../public/site/notificationStore.js';
import { TypeKeys } from '../../selfservice/actions';
import {
  isDisplaySessionExpiredNotification,
  removeDisplaySessionExpiredNotification,
} from '../../selfservice/common/localStorageUtils';
import { t } from '../i18n';

export const useSessionExpiredChecker = () => {
  const { isAuthenticated } = useAuth();
  const { items } = useNotifications();
  const notificationIsVisible = items.some(notification => notification.id === TypeKeys.SESSION_EXPIRED);
  useEffect(() => {
    if (isAuthenticated) {
      if (notificationIsVisible) {
        removeDisplaySessionExpiredNotification();
        removeNotification(TypeKeys.SESSION_EXPIRED);
      }
    } else if (isDisplaySessionExpiredNotification()) {
      removeDisplaySessionExpiredNotification();
      if (!notificationIsVisible) {
        addNotificationWithoutTimer(
          {
            id: TypeKeys.SESSION_EXPIRED,
            text: t.SSJ9('Your session has expired. Please log in again to continue.'),
            type: 'info',
          },
          () => removeDisplaySessionExpiredNotification()
        );
      }
    }
  }, [isAuthenticated, notificationIsVisible]);
};
